import { render, staticRenderFns } from "./SaleInfoTable.vue?vue&type=template&id=203e9bba&scoped=true"
import script from "./SaleInfoTable.vue?vue&type=script&lang=js"
export * from "./SaleInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e9bba",
  null
  
)

export default component.exports